import script from "./CustomerTypeSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerTypeSelection.vue?vue&type=script&setup=true&lang=js"

import "./CustomerTypeSelection.vue?vue&type=style&index=0&id=f7b6db62&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7b6db62"]])

export default __exports__